import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resumin--transient-class"
export default class extends Controller {
  static targets = ["item"];
  static classes = ["active"];
  static values = {
    cooldown: { type: Number, default: 150 }, // ms
  };

  connect() {
    this.timer = null;
  }

  disconnect() {
    if (!this.timer) return;
    clearTimeout(this.timer);
    this.timer = null;
  }

  trigger() {
    this._add();
    this._resetTimer();
  }

  // Private methods

  _add() {
    for (const el of this.itemTargets) {
      el.classList.add(this.activeClass);
    }
  }

  _remove() {
    for (const el of this.itemTargets) {
      el.classList.remove(this.activeClass);
    }
  }

  _resetTimer() {
    if (this.timer) clearTimeout(this.timer);

    this.timer = setTimeout(() => {
      this._remove();
    }, this.cooldownValue);
  }
}
